const normalize = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase();

export const getCervedProvinceDifference = (
  currentProvinceId,
  currentProvinceText,
  cervedProvinceText,
  provinceList = [],
) => {
  const currentProvince =
    provinceList.find(
      (province) =>
        currentProvinceId !== null &&
        currentProvinceId !== undefined &&
        String(province.id) === String(currentProvinceId),
    ) ??
    provinceList.find((province) => {
      const normalizedText = normalize(currentProvinceText);
      return (
        normalizedText !== "" &&
        (normalize(province.sigla) === normalizedText ||
          normalize(province.nome) === normalizedText)
      );
    });
  const cervedProvince = provinceList.find((province) => {
    const normalizedText = normalize(cervedProvinceText);
    return (
      normalizedText !== "" &&
      (normalize(province.sigla) === normalizedText ||
        normalize(province.nome) === normalizedText)
    );
  });
  const normalizedCerved = normalize(cervedProvinceText);
  const currentValue = currentProvince?.nome ?? currentProvinceText;
  if (normalizedCerved === "") {
    return { currentValue, hasDifference: false };
  }

  const currentAliases = currentProvince
    ? [normalize(currentProvince.sigla), normalize(currentProvince.nome)]
    : [];

  let hasDifference;
  if (currentProvince && cervedProvince) {
    hasDifference = String(currentProvince.id) !== String(cervedProvince.id);
  } else if (currentProvince) {
    hasDifference = !currentAliases.includes(normalizedCerved);
  } else {
    hasDifference = normalize(currentProvinceText) !== normalizedCerved;
  }

  return {
    currentValue,
    hasDifference,
  };
};